import { HorizontalFlex } from "@enxcs/dap-ui-stratos";
import { useCallback } from "react";

import LoadingSpinner from "./LoadingSpinner";

const LoadingRow = () => {
  const setLoadingComponent = useCallback(
    () => (
      <HorizontalFlex $justify="flex-end">
        <LoadingSpinner />
      </HorizontalFlex>
    ),
    [],
  );

  return setLoadingComponent();
};

export default LoadingRow;
